import PropTypes from 'prop-types'

import { PhoneContent } from './components/PhoneContent'
import * as S from './styled'

const CallCenterContent = ({ whatsappEnabled }) => {
  const whatsappIsEnabled = Boolean(whatsappEnabled)

  return (
    <S.Wrapper>
      <S.Heading>
        Compre pelo Telefone
      </S.Heading>

      <div>
        {whatsappIsEnabled && (
          <PhoneContent
            iconType={'whatsapp'}
            link={'https://api.whatsapp.com/send?phone=551140071380'}
            phoneNumber={'(11) 4007-1380'}
            locale={'Nacional'}
          />
        )}
        <PhoneContent
          link={'tel:+55-11-4007-1380'}
          phoneNumber={'4007-1380'}
          locale={'Capitais'}
        />
        <PhoneContent
          link={'tel:+55-0800-602-1380'}
          phoneNumber={'0800-602-1380'}
          locale={'Demais regiões'}
        />
      </div>
    </S.Wrapper>
  )
}

CallCenterContent.propTypes = {
  whatsappEnabled: PropTypes.string.isRequired
}

export default CallCenterContent
